import * as React from 'react';
import './RecentOrder.scss';
import LocaleFormating from 'src/translation/localeFormating';
import { goToOrdersDetail, ordersDetailUrl } from 'src/utils/navigation';
import i18n from 'src/translation/i18n';
import defaultImage from 'src/assets/defaultImage';

// Describes in one word different Order statuses
// Got possible statuses from backend
export function simplifyStatus(
  status: string
): { description: string; color: string } {
  switch (status.toLowerCase()) {
    case 'sales order entered':
      return {
        description: `${i18n.t('recentOrders.statusKeys.pending')}`,
        color: 'yellow'
      };
    case 'orders to be delivered later':
      return {
        description: `${i18n.t('recentOrders.statusKeys.pending')}`,
        color: 'yellow'
      };
    case 'order confirmation printed':
      return {
        description: `${i18n.t('recentOrders.statusKeys.processing')}`,
        color: 'yellow'
      };
    case 'pick list printed':
      return {
        description: `${i18n.t('recentOrders.statusKeys.processing')}`,
        color: 'yellow'
      };
    case 'pick list confirmed':
      return {
        description: `${i18n.t('recentOrders.statusKeys.processing')}`,
        color: 'yellow'
      };
    case 'transport note printed':
      return {
        description: `${i18n.t('recentOrders.statusKeys.processing')}`,
        color: 'yellow'
      };
    case 'under invoicing':
      return {
        description: `${i18n.t('recentOrders.statusKeys.invoicing')}`,
        color: 'yellow'
      };
    case 'invoiced':
      return {
        description: `${i18n.t('recentOrders.statusKeys.invoiced')}`,
        color: 'green'
      };
    case 'shipment pending':
      return {
        description: `${i18n.t('recentOrders.statusKeys.shipmentPending')}`,
        color: 'green'
      };
    case 'order received':
      return {
        description: `${i18n.t('recentOrders.statusKeys.orderReceived')}`,
        color: 'green'
      };
    case 'order in process':
      return {
        description: `${i18n.t('recentOrders.statusKeys.orderInProcess')}`,
        color: 'green'
      };
    case 'backordered':
      return {
        description: `${i18n.t('recentOrders.statusKeys.backordered')}`,
        color: 'green'
      };
    default:
      return { description: status, color: 'green' };
  }
}

interface IRecentOrderProps {
  showSeparator: boolean;
  orderNo: number;
  date: string;
  status: string;
  productNo: string;
  image: string;
}

export class RecentOrder extends React.Component<IRecentOrderProps, any> {
  private goToOrder = () => {
    goToOrdersDetail(this.props.orderNo.toString());
  };

  public render() {
    // const status = simplifyStatus(this.props.status);
    return this.order();
    // <a
    //   href={ordersDetailUrl(this.props.orderNo.toString())}
    //   className="rp-recent-order--link"
    // >
    //   <div className="rp-recent-order" onClick={this.goToOrder}>
    //     <div className="container-fluid">
    //       <div className="row no-gutters">
    //         <div className="col-7">
    //           <div className="rp-recent-order--details">
    //             <div>#{this.props.orderNo}</div>
    //             <div>
    //               {LocaleFormating.formatDate(this.props.date, 'short')}
    //             </div>
    //             <div>
    //               Status:{' '}
    //               <span className={`rp-recent-order--status ${status.color}`}>
    //                 {status.description}
    //               </span>
    //             </div>
    //           </div>
    //         </div>
    //         <div className="col-5 rp-recent-order--track-col">
    //           <div className={`rpds-place`} />
    //           <div className="rp-recent-order--track">TRACK</div>
    //           {this.props.showSeparator ? (
    //             <span className="rp-recent-order--separator" />
    //           ) : null}
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </a>
  }

  public order = () => {
    const status = simplifyStatus(this.props.status);
    // let recentOrderImage : any[];
    // if (this.props.image === null) {
    //   this.props.image = defaultImage;
    // } else {

    // }
    const recentOrderImage =
      this.props.image === null ? defaultImage : this.props.image;

    // console.log(this.props);
    return (
      <div className="row rp-recent-card roboto">
        <div className="col-md-5 col-12 rp-recent-card--img-section">
          <img alt={this.props.productNo} className="rp-recent-order-image" src={recentOrderImage} />
        </div>
        <div className="col-md-7 col-12 rp-recent-card--info-section">
          <p className="rp-product-number">{this.props.productNo}</p>
          <p className="rp-order-text">
            {i18n.t('common.order')}:<span>#{this.props.orderNo}</span>
          </p>
          <p className="rp-order-date">
            {i18n.t('common.date')}:{' '}
            <span>{LocaleFormating.formatDate(this.props.date, 'short')}</span>
          </p>
          <p className="rp-order-status">
            {i18n.t('myReturns.status')}:{' '}
            <span className={`rp-recent-order--status ${status.color}`}>
              <span>{status.description}</span>
            </span>
          </p>
          <div className="track-button">
            <button
              className="rp-recent-order--track-col"
              onClick={this.goToOrder}
            >
              {i18n.t('recentOrders.track')}
            </button>
          </div>
        </div>
      </div>
    );
  };
}
